/** Created by azhou on 2019/4/8.*/
<template>
  <ul class="list-item">
    <li class="w-15 list-item-col">平台返点</li>
    <li class="w-20 list-item-col">&yen; {{Itemize.pay_money / 100 | formatMoney}} 元</li>
    <li class="w-15 list-item-col">&yen; {{Itemize.money / 100 | formatMoney}} 元</li>
    <li class="w-40 list-item-col flex-column">
      <span>{{Itemize.adtime | formatTimestamp(1)}}</span>{{Itemize.order_no}}
    </li>
    <li class="w-30 list-item-col">{{Itemize.trade_no}}</li>
    <li class="w-10 list-item-col-end">{{Itemize.remark || '暂无说明'}}</li>
  </ul>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 'ItemizeRebate',
    props:{
      Itemize:{}
    },
    computed:{
      ...mapGetters(['userInfo'])
    }
  }
</script>
